import { Collapse, Grid, Tooltip } from "@material-ui/core";
import { useJobDetails } from "domains/Task/components/Job/JobRightSideUtils";
import { Order, Parcel } from "generated/graphql";
import { CollectIcon, DetailsIcon, IIcon, ParcelIcon, PriceIcon, SizeIcon } from "icons";
import React from "react";

interface RecapViewProps {
  order?: Order;
}

export const RecapView = ({ order }: RecapViewProps) => {
  const styles = useJobDetails();

  const [openIconButton, setOpenIconButton] = React.useState(false);

  return (
    <div className={styles.orderStyle}>
      <div className={styles.collapseContent} onClick={() => setOpenIconButton(!openIconButton)}>
        <Grid className={styles.collapse}>
          <Grid xs={3} className={styles.iconStyle}>
            <ParcelIcon width={63} height={63} color="#fff" />
          </Grid>
          <Grid xs={6} className={styles.receiverInfo}>
            <Grid className={styles.clientName}>
              {order?.order_receiver?.receiver_firstname} {order?.order_receiver?.receiver_lastname}
            </Grid>
            <div className={styles.clientPhone}>{order?.order_receiver?.receiver_phone_number}</div>
            <div className={styles.clientAddresses}>
              <Tooltip title={order?.order_receiver?.receiver_address?.address}>
                <span> {`${order?.order_receiver?.receiver_address?.address.substring(0, 25)}...`}</span>
              </Tooltip>
            </div>
          </Grid>
          <div className={styles.clientParcels}>{order?.order_parcels?.length}</div>
          {/* {order?.relay && <div className={styles.rp}>RP</div>} */}
        </Grid>
        <Collapse in={openIconButton} timeout="auto" unmountOnExit className={styles.collapseStyle}>
          {order?.order_parcels.map((parcel) => (
            <ParcelsRecap parcel={parcel} />
          ))}
        </Collapse>
      </div>
    </div>
  );
};

interface ParcelRecapProps {
  parcel?: Parcel;
}

export const ParcelsRecap = ({ parcel }: ParcelRecapProps) => {
  const styles = useJobDetails();

  return (
    <div className={styles.parcelRoot}>
      <div style={{ display: "flex", position: "relative", bottom: -4, left: "12px" }}>
        <div className={styles.iconInfo}>
          <DetailsIcon />
        </div>
        <div className={styles.parcelRoot2}>
          <p className={styles.parcelDesc}>{parcel?.parcel_description}</p>
          <p>{parcel?.parcel_client_reference}</p>

          <div className={styles.parcelRoot3}>
            <p>
              <span>
                <SizeIcon width={15} height={15} color="#399ebf" />
              </span>
              {parcel?.parcel_size}
            </p>
            <p>
              <span>
                <PriceIcon width={14} height={14} color="#399ebf" />
              </span>
              {parcel?.parcel_amount_to_collect}
            </p>
            <p>
              <span>
                <CollectIcon width={14} height={14} color="#399ebf" />
              </span>
              {parcel?.parcel_value}
            </p>
          </div>
        </div>
      </div>

      <div className={styles.parcelInfom}>
        <span className={styles.iconInfo2}>
          <IIcon />
        </span>
        <p style={{ width: "75%", textAlign: "justify" }}>
          {parcel?.parcel_additional_info ? parcel?.parcel_additional_info : "N/A"}
        </p>
      </div>
    </div>
  );
};
